const handleCloseMyCompany = {
  confirm: 'Deseja realmente sair sem salvar as alterações?',
  title: 'ALTERAÇÕES NÃO SALVAS'
};

export default handleCloseMyCompany;
